import { i18n } from "translate/i18n";

export const weCouldNotFindThisPage = i18n.t(`messages.weCouldNotFindPage`);
export const thePossibleReasons = i18n.t(`messages.thePossibleReasons`);
export const thePossibleReasons1 = i18n.t(`messages.pageNotExist`);
export const thePossibleReasons2 = i18n.t(`messages.thePossibleReasons2`);
export const thePossibleReasons3 = i18n.t(`messages.thePossibleReasons3`);
export const whatYouCanDo = i18n.t(`messages.whatYouCanDo`);
export const whatYouCanDo1 = i18n.t(`messages.verifyUpdate`);
